import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';

import ChevronDown from 'shared/components/icon/ChevronDown';
import ChevronRight from 'shared/components/icon/ChevronRight';
import * as Text from 'shared/utils/Text';

import styles from './index.module.scss';
import OwnReductionToolbar from './OwnReductionToolbar';
import PointReductionToolbar from './PointReductionToolbar';
import TrendViewToolbar from './TrendViewToolbar';

const Toolbar = ({
  betType,
  betInformation,
  isLocked,
  raceInformation,
  pointReductionIndex,
  pointSource,
  trendTime,
  viewType,

  getTrendMinutes,
  onChangeTrendTime,
  onResetOwnWinPercentages,
  onSetPointDisplay,
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = useCallback(
    () => setMobileMenuOpen(!mobileMenuOpen),
    [setMobileMenuOpen, mobileMenuOpen],
  );

  const headings = {
    'view-own-reduction': 'toolbar-own-reduction-header',
    'view-point-reduction': 'toolbar-point-heading',
    'view-trend': 'toolbar-trend-heading',
  };

  const header = Text.get(headings[viewType]);

  return (
    <div className={styles.toolbar}>
      <div className={styles.inner}>
        <div
          className={classnames(styles.header, {
            [styles.active]: mobileMenuOpen,
          })}
          onClick={toggleMobileMenu}
        >
          <div className={styles.headerText}>
            {header}
            {viewType === 'view-trend' && trendTime && (
              <span className={styles.mobileDetails}>({trendTime})</span>
            )}
            <ChevronDown className={styles.chevronMobile} />
          </div>
          <ChevronRight className={styles.chevron} />
        </div>

        <div
          className={classnames(styles.actionsColumn, {
            [styles.active]: mobileMenuOpen,
            [styles.full]: viewType === 'view-own-reduction',
          })}
        >
          {viewType === 'view-trend' && (
            <TrendViewToolbar
              getTrendMinutes={getTrendMinutes}
              isLocked={isLocked}
              onChangeTrendTime={onChangeTrendTime}
              trendTime={trendTime}
            />
          )}

          {viewType === 'view-own-reduction' && (
            <OwnReductionToolbar
              isLocked={isLocked}
              raceInformation={raceInformation}
              onReset={onResetOwnWinPercentages}
              rows={betInformation.getRows()}
            />
          )}

          {viewType === 'view-point-reduction' && (
            <PointReductionToolbar
              index={pointReductionIndex}
              betType={betType}
              isInternationalRace={betInformation.hasInternationalTrack()}
              isLocked={isLocked}
              onChange={onSetPointDisplay}
              pointSource={pointSource}
            />
          )}
        </div>
      </div>
    </div>
  );
};

Toolbar.propTypes = {
  betInformation: PropTypes.object.isRequired,
  isLocked: PropTypes.bool,
  pointReductionIndex: PropTypes.number,
  pointSource: PropTypes.string,
  raceInformation: PropTypes.object.isRequired,
  trendTime: PropTypes.string,
  viewType: PropTypes.string.isRequired,

  getTrendMinutes: PropTypes.func,
  onChangeTrendTime: PropTypes.func,
  onResetOwnWinPercentages: PropTypes.func,
  onSetPointDisplay: PropTypes.func,
};

export default Toolbar;
